import { render, staticRenderFns } from "./pays.vue?vue&type=template&id=b3fc6a9e"
import script from "./pays.vue?vue&type=script&lang=js"
export * from "./pays.vue?vue&type=script&lang=js"
import style0 from "./pays.vue?vue&type=style&index=0&id=b3fc6a9e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports